import { IconCube } from '@smartbear/swagger-portal-component-library'

import { CommonSearchResultTile, HighlightedTitle } from '../CommonSearchResultTile'
import { isAsyncApi, isDefinitionMarkdown } from '~/portal/components/SearchModal/helpers'
import { SearchResult } from '~/portal/types/search'

interface SchemaSearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const SchemaSearchResultTile = ({ result, onClose, tileKey }: SchemaSearchResultTileProps) => {
  const isAsync = isAsyncApi(result)
  const schemaIdentifier = isAsync ? result.schemaName : (result.schemaTitle || result.schemaName)
  const url = isDefinitionMarkdown(result)
    ? `/${result.product.slug}/${result.href}#${encodeURIComponent(result.componentAnchorId || '')}`
    : isAsync
      ? `/${result.product.slug}/${result.href}#/schema-${schemaIdentifier}`
      : `/${result.product.slug}/${result.href}#/${schemaIdentifier}`

  const icon = <IconCube width={16} height={16} />

  const titleContent = <HighlightedTitle titleSnippet={result.titleSnippet} />

  return (
    <CommonSearchResultTile
      result={result}
      onClose={onClose}
      tileKey={tileKey}
      icon={icon}
      url={url}
      titleContent={titleContent}
    />
  )
}
